import { render, staticRenderFns } from "./manSwiper.vue?vue&type=template&id=865ad0a6&scoped=true&"
import script from "./manSwiper.vue?vue&type=script&lang=js&"
export * from "./manSwiper.vue?vue&type=script&lang=js&"
import style0 from "./manSwiper.vue?vue&type=style&index=0&id=865ad0a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865ad0a6",
  null
  
)

export default component.exports